type SendFn = (message: string) => Promise<boolean>;

export class SendQueue {
  private queue: string[] = [];
  private isFlushing = false;
  private sendFn: SendFn | null = null;

  setSendFn(fn: SendFn) {
    this.sendFn = fn;
  }

  enqueue(message: string) {
    this.queue.push(message);
    this.flush();
  }

  onConnected() {
    this.flush();
  }

  private async flush() {
    if (this.isFlushing) return;
    if (!this.sendFn) return;

    this.isFlushing = true;

    while (this.queue.length > 0) {
      const message = this.queue[0];
      const success = await this.sendFn(message);

      if (success) {
        this.queue.shift();
      } else {
        // send 실패 시 큐 맨 앞에 메시지를 유지하고 중단
        break;
      }
    }

    this.isFlushing = false;
  }

  cleanup() {
    this.queue = [];
    this.isFlushing = false;
    this.sendFn = null;
  }
}
